import type { ImgConfigState } from './type'
import { defineStore } from 'pinia'
import { getImgConfig } from '@/service/apis'

const imgConfigStore = defineStore('imgConfig', {
  state(): ImgConfigState {
    return {
      imgConfig: {
        gameLogoImageFillet: '0', //圆角弧度
        gameLogoImageFilletError: '0', //圆角弧度误差
        gameLogoImageAlpha: '0', // 弧度 alpha 值
        gameLogoImageFilletSwitch: '0' // 圆角弧度检测开关
      }
    }
  },
  actions: {
    getImgConfig() {
      getImgConfig({}).then((res) => {
        console.log('res------>', res)
        const { imgConfig } = res.data
        Object.assign(this.imgConfig, imgConfig)
      })
    }
  }
})

export default imgConfigStore
